import { getNotificationSettingsStore } from '../store/store';
import { patchNotificationSettings } from '../service/patchNotificationSettings';
import { setIsNotificationSettingsDirty } from '../mutators/setIsNotificationSettingsDirty';
import { resetBackupNotificationSettings } from '../mutators/resetBackupNotificationSettings';
export default function saveDesktopNotificationSetting() {
    patchNotificationSettings(getNotificationSettingsStore().settings).then(isSuccessful => {
        if (isSuccessful) {
            setIsNotificationSettingsDirty(false);
        }
    });
    resetBackupNotificationSettings();
}
